import moment from "moment/moment";
import {capitalizeFirstLetter} from "../string";

export const formatDateMonthYear = (date) => {
  return capitalizeFirstLetter(moment(date).format("MMM YYYY"));
};
